import { useQuery } from '@tanstack/react-query';
import http from "@/lib/http";
export const useGeoKeywordsByCourse = courseName => {
  return useQuery({
    queryKey: ['geoKeywords', courseName],
    queryFn: async () => {
      if (!courseName) return [];
      const res = await http.get(`https://api.hachion.co/api/admin/geo-keywords/by-course`, {
        params: {
          courseName
        }
      });
      return res.data?.geoKeywords || [];
    },
    enabled: !!courseName,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity
  });
};
